var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlexibleDeadlines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19C0 8.50659 8.50659 0 19 0C29.4934 0 38 8.50659 38 19C38 29.4934 29.4934 38 19 38C8.50659 38 0 29.4934 0 19Z",
    fill: "#1A89A0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_393_5977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 6.6499C17.8324 6.6499 16.8772 7.6051 16.8772 8.77256C16.8772 9.94002 17.8324 10.8952 18.9999 10.8952C20.1673 10.8952 21.1225 9.94002 21.1225 8.77256C21.1225 7.6051 20.1673 6.6499 18.9999 6.6499ZM18.9999 10.2938C18.1508 10.2938 17.4786 9.62162 17.4786 8.77256C17.4786 7.9235 18.1508 7.25132 18.9999 7.25132C19.8489 7.25132 20.5211 7.9235 20.5211 8.77256C20.5211 9.62162 19.8489 10.2938 18.9999 10.2938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4692 9.69238H19.5306V11.9919H18.4692V9.69238Z",
    fill: "#05060B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8844 9.86944C19.8844 10.3579 19.4884 10.7539 18.9999 10.7539C18.5115 10.7539 18.1155 10.3579 18.1155 9.86944V8.73735C18.1155 8.20669 19.8844 8.20669 19.8844 8.73735V9.86944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4775 13.9682L12.5279 12.9175L13.5786 13.9678L12.5286 15.0186L11.4775 13.9682Z",
    fill: "#05060B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1979 12.8765L11.429 14.6454L10.3323 13.5487C10.12 13.3364 10.12 12.9826 10.3323 12.7704L11.3229 11.7798C11.5351 11.5675 11.8889 11.5675 12.1012 11.7798L13.1979 12.8765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4282 13.975L25.4789 12.9243L26.5297 13.975L25.4789 15.0257L24.4282 13.975Z",
    fill: "#05060B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5706 14.6449L24.8018 12.876L25.8985 11.7793C26.1107 11.5671 26.4645 11.5671 26.6768 11.7793L27.6673 12.7699C27.8796 12.9822 27.8796 13.3359 27.6673 13.5482L26.5706 14.6449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 29.2913C23.8845 29.2913 27.8443 25.3316 27.8443 20.4469C27.8443 15.5623 23.8845 11.6025 18.9999 11.6025C14.1153 11.6025 10.1555 15.5623 10.1555 20.4469C10.1555 25.3316 14.1153 29.2913 18.9999 29.2913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 28.1239C23.2398 28.1239 26.6769 24.6868 26.6769 20.447C26.6769 16.2071 23.2398 12.77 18.9999 12.77C14.7601 12.77 11.323 16.2071 11.323 20.447C11.323 24.6868 14.7601 28.1239 18.9999 28.1239Z",
    fill: "#D2D3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 27.5226C22.9075 27.5226 26.0754 24.3548 26.0754 20.4471C26.0754 16.5394 22.9075 13.3716 18.9998 13.3716C15.0921 13.3716 11.9243 16.5394 11.9243 20.4471C11.9243 24.3548 15.0921 27.5226 18.9998 27.5226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0755 20.4471C26.0755 22.3929 25.2972 24.1617 24.0236 25.4353L19 20.4471V13.3716C22.8915 13.3716 26.0755 16.5556 26.0755 20.4471Z",
    fill: "#FFA64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0685 24.4804L19.46 20.1997L18.7524 20.9073L23.0685 24.4804Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7524 13.9731H19.2477V15.9543H18.7524V13.9731Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7524 24.9404H19.2477V26.9216H18.7524V24.9404Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5259 20.1997H14.507V20.695H12.5259V20.1997Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4929 20.1997H25.4741V20.695H23.4929V20.1997Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5251 14.9508L15.9543 14.7031L16.4496 15.561L16.0204 15.8087L15.5251 14.9508Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2434 17.4268L13.4911 16.998L14.349 17.4933L14.1013 17.9225L13.2434 17.4268Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2549 23.494L14.1124 22.998L14.3601 23.4268L13.5029 23.9228L13.2549 23.494Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5513 25.9575L16.0466 25.0996L16.4753 25.3473L15.98 26.2052L15.5513 25.9575Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5322 25.3033L21.961 25.0557L22.4563 25.9136L22.0279 26.1612L21.5322 25.3033Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6345 23.4296L23.8822 23.0005L24.7401 23.4961L24.4924 23.9253L23.6345 23.4296Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6082 17.4855L24.4657 16.9902L24.7134 17.419L23.8558 17.9143L23.6082 17.4855Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5244 15.5475L22.0201 14.6899L22.4488 14.9376L21.9535 15.7955L21.5244 15.5475Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 21.4377C19.5472 21.4377 19.9907 20.9942 19.9907 20.4471C19.9907 19.9 19.5472 19.4565 19.0001 19.4565C18.453 19.4565 18.0095 19.9 18.0095 20.4471C18.0095 20.9942 18.453 21.4377 19.0001 21.4377Z",
    fill: "#3E4347"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_393_5977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.7,
    height: 24.7,
    fill: "white",
    transform: "translate(6.6499 6.6499)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexibleDeadlines);
export default __webpack_public_path__ + "static/media/flexible-deadlines.58a7b382.svg";
export { ForwardRef as ReactComponent };